var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maxRelevance)?_c('span',{staticClass:"score",class:_vm.relevanceTier},[_c('span',{staticClass:"bar-1"}),_c('span',{staticClass:"bar-2"}),_c('span',{staticClass:"bar-3"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }